import { FC } from 'react';
import styled from 'styled-components';
import { typography } from 'src/common/styles/typography';
import { FormattedMessage } from 'react-intl';
import { SimpleLink } from 'src/common/components/SimpleLink';
import { buildPublicUrlLink } from 'src/utils/buildPublicUrlLink';
import { rgba } from 'polished';

const Info = styled.div`
  grid-area: info;
  max-width: 18.75rem;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Description = styled.p`
  height: 6rem;
  width: 18.875rem;
  color: ${({ theme }) => rgba(theme.text.primary, 0.7)};
  font-family: ${typography.fontFamilyDefault};
  font-size: 1rem;
`;

const Title = styled.p`
  color: ${({ theme }) => theme.text.primary};
  font-family: ${typography.fontFamilyDefault};
  font-size: 1.25rem;
  font-weight: bold;
`;

const StyledSimpleLink = styled(SimpleLink)`
  color: ${({ theme }) => theme.text.primary};
  text-decoration: none;
`;

const FooterDataInfo: FC = () => {
  return (
    <Info>
      <Title>
        {' '}
        <FormattedMessage id="footer.buildTrust" />
      </Title>
      <Description>
        <FormattedMessage
          id="footer.dataPrivacy"
          values={{
            privacyPolicyLink: (str) =>
              (
                <StyledSimpleLink
                  target="_blank"
                  href={buildPublicUrlLink('docs/AIS_Polityka_prywatności.pdf')}
                >
                  {str}
                </StyledSimpleLink>
              ) as any,
          }}
        />
      </Description>
    </Info>
  );
};

export default FooterDataInfo;
